import { SearchCriterion, HasCriteria } from "./criteria";

export interface CriteriaFilter {
    criteria: SearchCriterion[]
}

export function getCriteria<T extends HasCriteria>(item: T, key: string) {
    const value = item?.criteria?.filter((kv: SearchCriterion) => kv.key === key)[0]
    return value
}

export function criteriaToMap<T extends HasCriteria>(item: T, strFilter = (s: string) => s): Map<string, string> {
    const map = item?.criteria?.reduce((m: Map<string, string>, kv: SearchCriterion) => {
        const val = strFilter(kv.value)
        m.set(kv.key, val)
        return m
    }, new Map<string, string>())
    return map ?? new Map<string, string>()
}

export function filterByCriteria<T extends HasCriteria>(arr: T[], criteria: SearchCriterion[]) {
    return arr.filter(item => {
        const map = criteriaToMap(item)
        for (const {key, value} of criteria) {
            if (map.has(key) && map.get(key) !== value) {
                return false
            }
        }
        return true
    })
}
